import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=d5eb304a&"
import script from "./textArea.vue?vue&type=script&lang=ts&"
export * from "./textArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports